export const REFERRAL_INFO_KEY = 'referralInfo';
